import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';
import CambiaPassword from 'components/CambiaPassword';
import Icon from '../../components/AppIcon';

const ChangePassword = () => {
  const { t } = useTranslation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Navigacijski elementi */}
      <MobileMenuButton isOpen={isSidebarOpen} onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
      
      {/* Header sa naslovom stranice */}
      <DashboardHeader userName={t('change_password.title') || 'Sicurezza'} />

      <main className="main-content with-sidebar py-10 px-4 mt-20">
        <div className="max-w-5xl mx-auto">
          
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            {/* Dugme za nazad */}
            <button 
              onClick={() => navigate(-1)} 
              className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-bold uppercase text-[10px] tracking-widest"
            >
              <div className="p-2 bg-muted rounded-xl group-hover:bg-primary/10 transition-colors">
                <Icon name="ArrowLeft" size={16} />
              </div>
              {t('profile_page.back')}
            </button>
          </div>

          {/* Vizuelna linija / dekoracija */}
          <div className="mb-10">
            <div className="h-1 w-20 bg-primary mt-2 rounded-full"></div>
          </div>
          
          {/* Glavna komponenta za formu promjene lozinke */}
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <CambiaPassword />
          </div>
          
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default ChangePassword;